import { FetchResult, FetchStatus } from "../../../../base/types";

import { IServiceMetadata } from "../models";
import { useLazyGetAttributeOptionsQuery } from "./serviceAttributeOptionsApi";
import { useLazyGetAttributesQuery } from "./attributesMetadataApi";
import { useLazyGetServiceAttributesQuery } from "./serviceAttributesApi";
import { useLazyGetServiceQuery } from "./servicesApi";
import { useLazyGetStagesQuery } from "./serviceStagesApi";
import { useState } from "react";

interface IServiceMetadataResult extends FetchResult<IServiceMetadata> { }

export const useGetServiceMetadata = () => {
    const [result, setResult] = useState<IServiceMetadataResult>({ status: FetchStatus.Idle });
    const [getService] = useLazyGetServiceQuery()
    const [getStages] = useLazyGetStagesQuery()
    const [getAttributes] = useLazyGetAttributesQuery()
    const [getServiceAttributes] = useLazyGetServiceAttributesQuery()
    const [getAttributeOptions] = useLazyGetAttributeOptionsQuery()

    const getServiceMetadata = (serviceId: string): Promise<IServiceMetadata> => {
        setResult({ status: FetchStatus.Loading })

        return getStages()
            .unwrap()
            .then(stages => getAttributes()
                .unwrap()
                .then(attributes => getService(serviceId)
                    .unwrap()
                    .then(service => getServiceAttributes(service.id)
                        .unwrap()
                        .then(serviceAttributes => {
                            const filteredStages = stages.filter(p => serviceAttributes.find(a => a.serviceStageId === p.id));
                            const filteredAttributes = attributes.filter(p => serviceAttributes.find(a => a.attributeId === p.id));
                            return getAttributeOptions()
                                .unwrap()
                                .then(attributeOptions => Promise.resolve({ service, stages: filteredStages, serviceAttributes, attributes: filteredAttributes, attributeOptions }))
                                .catch(() => Promise.reject('Failed to load service attribute options'));
                        })
                        .catch(() => Promise.reject('Failed to load service attributes')))
                    .catch(() => Promise.reject('Failed to load service')))
                .catch(() => Promise.reject('Failed to load attributes')))
            .then(data => {
                setResult({ status: FetchStatus.Success, result: data });
                return Promise.resolve(data)
            })
            .catch(() => Promise.reject('Failed to load stages'))
            .catch(error => {
                setResult({ status: FetchStatus.Error, error });
                return Promise.reject(error)
            })
    }

    return { getServiceMetadata, result }
}
